import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Newsletter } from '../models/newsletter.model';
import { NewsletterInput } from '../models/newsletter-input.model';

export interface INewslettersRepository {
  list(organizationId: number): Observable<readonly Newsletter[]>;
  getById(organizationId: number, newsletterId: string): Observable<Newsletter>;
  create(organizationId: number, input: NewsletterInput): Observable<Newsletter>;
  update(
    organizationId: number,
    newsletterId: string,
    input: NewsletterInput,
  ): Observable<Newsletter>;
  delete(organizationId: number, newsletterId: string): Observable<void>;
  publish(
    organizationId: number,
    newsletterId: string,
    notifyByPush: boolean,
  ): Observable<Newsletter>;
  archive(organizationId: number, newsletterId: string): Observable<Newsletter>;
}

export const NEWSLETTERS_REPOSITORY = new InjectionToken<INewslettersRepository>(
  'INewslettersRepository',
);
